import { dealInfoHelpers } from 'widget/player-widget';
import commonTranslations from 'shared/translations/overlay-common-translations';
import formatMessageWithDealInfo from '../_format-message-with-deal-info';
import { getFullAccessActionName, FULL_ACCESS_ACTION_NAMES } from 'widget/ui-selectors/video-access';


/**
 * Is channel subscribe button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
export function isVisible({ channel, video }) {
  return getFullAccessActionName(channel, video) === FULL_ACCESS_ACTION_NAMES.SUBSCRIBE;
}

/**
 * Channel subscribe button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.translation {Object} default is commonTranslations.getSubscription
 * @return {React.Component}
 */
export default function renderSubscribeButtonText(props) {
  if (!isVisible(props)) {
    return null;
  }

  return formatMessageWithDealInfo(
    props.translation || commonTranslations.getSubscription,
    dealInfoHelpers.getSubscriptionPriceInfo(props.channel.dealInfo)
  );
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/video/subscribe-button-text.js